import { useSEO } from "@/lib/seo";
import { Reveal } from "@/components/Reveal";

export default function Blog() {
  useSEO("Blog", "Freight and logistics insights from Cargowyn Logistics Group — coming soon.");
  return (
    <div className="min-h-[70vh]">
      <section className="bg-[#0B192C] text-white pt-24 pb-20 relative overflow-hidden" data-testid="blog-hero">
        <div className="absolute inset-0 noise opacity-[0.05]" />
        <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
          <div className="flex items-center gap-3 mb-5"><span className="h-[2px] w-10 bg-[#FF5A00]" /><span className="font-head uppercase tracking-[0.3em] text-[#FF5A00] text-sm font-700">Insights</span></div>
          <h1 className="font-head font-black uppercase text-6xl md:text-8xl tracking-tighter leading-[0.85]">The Cargowyn Blog</h1>
        </div>
      </section>
      <section className="py-24 bg-[#F8FAFC]">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 text-center">
          <Reveal>
            <div className="border-2 border-dashed border-[#0B192C]/20 p-16" data-testid="blog-empty">
              <h2 className="font-head font-800 uppercase text-3xl tracking-tight">Articles coming soon</h2>
              <p className="text-[#475569] mt-4 text-lg">We're preparing practical guides on cross-border shipping, permits, heavy-haul planning and more. Check back shortly.</p>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
